<template>
  <div class="appHouseholdManage">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item :label="$t('lang.lab_receivePeriod')">
          <el-date-picker  type="month" :placeholder="$t('lang.lab_startDate')"   value-format="timestamp" v-model="startPeriodTs"></el-date-picker>
            <span style="padding: 0 1px">至</span>
          <el-date-picker  type="month" :placeholder="$t('lang.lab_endDate')"  value-format="timestamp" v-model="endPeriodTs" ></el-date-picker>
        </el-form-item>
         <el-form-item label="收费项目">
          <el-select
            v-model="configId"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_receiveConfig"
          >
            <el-option
              key
              :label="$t('lang.lab_please_Select')+detail.lab_receiveConfig"
              value
            ></el-option>
            <el-option
              v-for="item in feeReceiveConfigs"
              :key="item.configId"
              :label="item.feeName"
              :value="item.configId"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择日期 -->
        <el-form-item label="业务日期">
          <!-- <el-date-picker type="date" placeholder="业务日期"   value-format="timestamp" v-model="startTime"></el-date-picker> -->
          <el-date-picker  type="date" :placeholder="$t('lang.lab_startDate')"   value-format="timestamp" v-model="startTime"></el-date-picker>
            <span style="padding: 0 1px">至</span>
          <el-date-picker  type="date" :placeholder="$t('lang.lab_endDate')"  value-format="timestamp" v-model="endTime" ></el-date-picker>
        </el-form-item>
        <!-- 选择楼号 -->
        <el-form-item>
          <el-select v-model="houseId" @change="selectUnit" filterable>
            <el-option key :label="$t('lang.lab_floorName')" value></el-option>
            <el-option
              v-for="(item,index) in floorList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择单元号 -->
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom" filterable>
            <el-option key :label="$t('lang.lab_unitName')" value></el-option>
            <el-option
              v-for="(item,index) in unitList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择房间号 -->
        <el-form-item>
          <el-select v-model="roomid" filterable>
            <el-option key :label="$t('lang.lab_roomName')" value></el-option>
            <el-option
              v-for="(item,index) in roomList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 收费方式 -->
        <el-form-item :label="$t('lang.lab_payMethod')" prop="payMethod">
          <el-select v-model="payMethod">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_payMethod')" value></el-option>
            <el-option
              v-for="(item,index) in payMethodList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 关键字 -->
        <!-- <el-form-item>
          <el-input
            class="seachInput"
            v-model="keyword"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_username')"
          ></el-input>
        </el-form-item> -->
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary"  @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-row style="margin-left:2%;text-align: start;">
          <el-col :span="24">收款金额合计：{{receivedAmountCount|rounding}}</el-col>
        </el-row>
      </div>
      <el-table
        :data="tableData"
        class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :expand-row-keys="expands"
        :row-key="getRowKeys"
      >
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="55"
        ></el-table-column>
        <!-- 用户名 -->
        <el-table-column width="100"  prop="ownerName" :label="$t('lang.lab_username')"></el-table-column>
        <!-- 手机 -->
        <el-table-column prop="mobile"   width="120" :label="$t('lang.lab_phone')"></el-table-column>
        <!-- 小区 -->
        <el-table-column prop="gardenName"  width="100" :label="$t('lang.lab_village')"></el-table-column>
        <!-- 楼号 -->
        <el-table-column width="60" prop="houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
        <!-- 单元号 -->
        <el-table-column width="60" prop="unitName" :label="$t('lang.resourUnit')"></el-table-column>
        <!-- 房间号 -->
        <el-table-column prop="roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
        <!-- 建筑面积 -->
        <el-table-column prop="buildArea" :label="$t('lang.lab_preHouseholdArea')"></el-table-column>

        <el-table-column prop="feeName" :label="$t('lang.lab_feeName')"></el-table-column>
        <el-table-column :label="$t('lang.lab_amountOwed')" prop="receiveAmount"></el-table-column>

        <el-table-column prop="thisAmount" label="收款金额"></el-table-column>

        <el-table-column width="120px" prop="createTime" :label="$t('lang.lab_createFeeHTime')">
          <template slot-scope="scope">
            {{scope.row.createTime|timeYMD}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_feePeriodCount')" prop="period"></el-table-column>
      <!-- 缴费起始时间 -->
        <el-table-column  prop="beginDate" label="计费开始时间">
          <template slot-scope="scope" >
                {{scope.row.beginDate|timeYMD}}
          </template>
        </el-table-column>
        <!-- 缴费结束时间 -->
        <el-table-column  prop="minEndDate"  label="计费结束时间">
          <template slot-scope="scope">
                 {{scope.row.minEndDate|timeYMD}}
          </template>
        </el-table-column>
          <el-table-column prop="payMethod" :label="$t('lang.lab_payMethod')">
            <template slot-scope="scope">
            <span>{{ scope.row.payMethod | payMethodName }}</span>
          </template>
        </el-table-column>
                <el-table-column  label="缴款人" prop="personName"></el-table-column>
         <el-table-column label="收款人" prop="creatorName">
          <template slot-scope="scope">
            <span v-if="scope.row.state === '1500'">{{"历史导入"}}</span>
            <span v-else>{{scope.row.creatorName}}</span>
          </template>
         </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50,1000]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
 import {
    excelDownload
  } from '../../../config/download.js'
/**
 *@ClassName:
 *@Description:
 *@author:xubz
 *@Copyright:格众科技
 *@date:
 */
export default {
  data() {
    return {
      multipleSelection: [], // 多选框
      editableTabs: [], // tabs列表
      datevalues: [], // 开始结束时间绑定值
      houseId: '', // 楼层绑定值
      floorList: [], // 楼层下拉列表
      unitid: '', // 单元绑定值
      unitList: [], // 单元下拉列表
      roomid: '', // 房间绑定值
      roomList: [], // 房间下拉列表
      user: '0', // 身份
      tag: '0', // 标签
      keyword: '', // 手机或序号内容input
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      type: 1, // 楼号单元号房间号区分
      parentId: '',
      gardenId: '', // 小区编号
      Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'), // 身份列表
      receiveArrearSelects: this.$i18n.t('lang.lab_receiveArrearSelect'), // 标签列表
      appHouseholdManageListcheckbox: require('@/config/enum')
      .appHouseholdManageListcheckbox, // 是否隐藏复选框
      receiveAmountCount: '',
      revAmountCount: '',
      paidAmountCount: '',
      receiveArrearSelect: '0',

      // -------------------------------
      payMethodList: this.$i18n.t('lang.payMethodList'),
      expands: [],
      expandata: [],
      expandataFlag: false,
      receivedAmountCount: '',
      isExpand: false,
      payMethod: '',
      startTime: '',
      endTime: '',
      startPeriodTs: '',
      endPeriodTs: '',
      detail: this.$i18n.t('lang.feePay'), 
      feeReceiveConfigs:[],
      configId:''
    }
  },
  created() {
    // 小区编号
    this.gardenId = this.$store.getters.gardenId
     this.getDatePickers()
     this.feeReceiveConfigList()
    // 初始化
    
    // 获取楼号
    this.gardenGrids(this.gardenId)
    // this.editableTabs = this.$store.getters.getTabList
  },
  // 监听改变小区编号
  watch: {
    '$store.state.allGardenId': function (newFlag, oldFlag) {
      this.gardenId = this.$store.state.allGardenId
      this.gardenChange()
    },
    // '$store.state.tabList': function (newFlag, oldFlag) {
    //   this.editableTabs = this.$store.getters.getTabList
    // },
  },
  methods: {
    feeReceiveConfigList() {
      console.log(this.gardenId)
      let loading = this.$loading()
      let params = {
        gardenId: this.gardenId,
      }
      this.$get(`/feeReceiveConfigList/`, params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.feeReceiveConfigs = res.list
            this.configId=res.list[0].configId
          }
          this.feeDetailHistory()
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
      
    },
    excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lab_username'),
            this.$i18n.t('lang.lab_phone'),
            this.$i18n.t('lang.lab_village'),
            this.$i18n.t('lang.lab_buildingnum'),
            this.$i18n.t('lang.resourUnit'),
            this.$i18n.t('lang.lab_roomnum'),
            this.$i18n.t('lang.lab_preHouseholdArea'),
            this.$i18n.t('lang.lab_feeName'),
            this.$i18n.t('lang.lab_amountOwed'),
            this.$i18n.t('收款金额'),
            this.$i18n.t('lang.lab_createFeeHTime'),
            this.$i18n.t('lang.lab_feePeriodCount'),
            this.$i18n.t('计费开始时间'),
            this.$i18n.t('计费结束时间'),
            this.$i18n.t('lang.lab_payMethod'),
            this.$i18n.t('收款人'),
          ]
          let newArr = []
          let createTime = ''
          let beginDate = ''
          let minEndDate = ''
          let payMethod = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].createTime) {
                createTime = this.$options.filters['timeYMD'](this.tableData[i].createTime)
              }
              if (this.tableData[i].beginDate) {
                beginDate = this.$options.filters['timeYMD'](this.tableData[i].beginDate)
              }
              if (this.tableData[i].minEndDate) {
                minEndDate = this.$options.filters['timeYMD'](this.tableData[i].minEndDate)
              }
              payMethod = this.$getPayMethodName(this.tableData[i].payMethod)
              newArr.push({
                'ownerName': this.tableData[i].ownerName,
                'mobile': this.tableData[i].mobile,
                'gardenName': this.tableData[i].gardenName,
                'houseName': this.tableData[i].houseName,
                'unitName': this.tableData[i].unitName,
                'roomName': this.tableData[i].roomName,
                'buildArea': this.tableData[i].buildArea,
                'feeName': this.tableData[i].feeName,
                'receiveAmount': this.tableData[i].receiveAmount,
                'thisAmount': this.tableData[i].thisAmount,
                'createTime': createTime,
                'period': this.tableData[i].period,
                'beginDate': beginDate,
                'minEndDate':minEndDate,
                'payMethod':payMethod,
                'creatorName': this.tableData[i].creatorName
              })
            }
          }


          // 对应table数据的列字段名
          const filterVal = ['ownerName', 'mobile', 'gardenName', 'houseName', 'unitName', 'roomName', 'buildArea',
          'feeName','receiveAmount','thisAmount','createTime','period','beginDate','minEndDate','payMethod','creatorName'
          ]
          excelDownload(tHeader, filterVal, newArr, "实收明细表")
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
    // 初始化时间组件
    getDatePickers() {
       let d = new Date()
      let year1, month1, day1
      [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, 0]
      let date1 = new Date(year1, month1, day1).getTime()
      // this.datevalues.push(Date.parse(date1))
      // this.endTime = date1
      // this.endPeriodTs = date1
      this.endTime = date1
      // 前一天设定的日期时间
      let year2, month2, day2
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1]
      let date2 = new Date(year2, month2, day2).getTime()
      // this.datevalues.unshift(Date.parse(date2))
       this.startTime = date2
      //  this.startPeriodTs = date2
    },
    getRowKeys(row) {
      return row.receiveDetailId
    },
    feeDetailHistory() {
      debugger
          // if(this.startPeriodTs==''||this.startPeriodTs==null||this.startPeriodTs==undefined){
          //   this.$message.info('应收区间不能为空')
          //     return
          // }
          // if(this.endPeriodTs==''||this.endPeriodTs==null||this.endPeriodTs==undefined){
          //   this.$message.info('应收区间不能为空')
          //     return
          // }
            let loading = this.$loading()
            let params = {
              pageNo: this.pageNo,
              pageSize: this.pageSize,
              gardenId: this.gardenId,
              houseId: this.houseId,
              unitId: this.unitid,
              roomId: this.roomid,
              startPeriodTs: this.startPeriodTs,
              endPeriodTs: this.endPeriodTs,
              payMethod: this.payMethod,
              businessStartTs:this.startTime,
              businessEndTs:this.endTime,
              configId:this.configId
            }
            this.$get(`/feeReceiptsDetailByGardenId/`, params).then(
              (res) => {
                loading.close()
                if (res && res.errCode === 0) {
                   this.receivedAmountCount = ''
                   if (res.list != null && res.list.length > 0) {
                      this.receivedAmountCount = res.list[0].thisAmountCount
                   }
                  this.tableData = res.list
                  console.log(this.tableData)
                  this.pageCount = res.pageCount
                }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
              }
            )
          },

    // 初始化时间组件
    // getDatePicker() {
    //    let d = new Date()
    //   let year1, month1, day1
    //   [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, 0]
    //   let date1 = new Date(year1, month1, day1)
    //   this.datevalues.push(Date.parse(date1))
    //   // 前一天设定的日期时间
    //   let year2, month2, day2
    //   [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1]
    //   let date2 = new Date(year2, month2, day2)
    //   this.datevalues.unshift(Date.parse(date2))
    // },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 添加多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 改变小区
    gardenChange() {
      this.houseId = ''
      this.feeDetailHistory()
      this.unitid = ''
      this.roomid = ''
      this.unitList = ''
      this.roomList = ''
      this.type = 1
      this.gardenGrids(this.gardenId)
    },
    // 获取楼号单元号房间号
    gardenGrids(parentId) {
      let loading = this.$loading()
      this.$get(
        `/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            if (this.type === 1) {
              this.floorList = res.list
            } else if (this.type === 2) {
              this.unitList = res.list
              this.roomList = ''
              if (this.houseId === '') {
                this.unitList = ''
                this.roomList = ''
              }
            } else if (this.type === 3) {
              this.roomList = res.list
              if (this.unitid === '') {
                this.roomList = ''
              }
            }
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 提交
    submit() {
      this.pageNo = 1
      this.feeDetailHistory()
    },
    // 通过楼层选择单元号
    selectUnit() {
      this.type = 2
      this.gardenGrids(this.houseId)
      this.unitid = ''
      this.roomid = ''
    },
    // 通过单元选择房间号
    selectRoom() {
      this.type = 3
      this.gardenGrids(this.unitid)
      this.roomid = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.feeDetailHistory()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.feeDetailHistory()
    },
  },
  filters: {
    rounding (value) {
      if (value == undefined || value == '') {
          value = 0
      }
     return value.toFixed(2)
    }
  }
}
</script>

<style lang= 'scss'>
</style>
